import React from "react";

import { mainViewStore } from "./mainViewStore";

export const StoreContext = React.createContext({
  mainViewStore,
});

export * from "./mainViewStore";
